import { render, staticRenderFns } from "./EnterPhoneDetail.vue?vue&type=template&id=2366a8a5&scoped=true"
import script from "./EnterPhoneDetail.vue?vue&type=script&lang=js"
export * from "./EnterPhoneDetail.vue?vue&type=script&lang=js"
import style0 from "./EnterPhoneDetail.vue?vue&type=style&index=0&id=2366a8a5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366a8a5",
  null
  
)

export default component.exports